import UntitledIcon from '@payaca/untitled-icons';
import './OfflineBanner.sass';

const OfflineBanner = () => {
  if (!navigator.onLine) {
    return (
      <div className="offline-banner">
        <UntitledIcon name="wifi-off.2" className="size-5" />
        Looks like you&#39;re offline, please check your connection. Your Payaca
        experience may be affected until you&#39;re back online.
      </div>
    );
  }
  return null;
};

export default OfflineBanner;
